import crimeIcon from "../assets/imgs/layout/crimes.png";
import travelIcon from "../assets/imgs/layout/location.png";
import gameIcon from "../assets/imgs/layout/game.png";
import miscIcon from "../assets/imgs/layout/misc.png";
import killIcon from "../assets/imgs/layout/target.png";
import config from "../config/config";

export const SideNavLinks = [
  {
    category: "FEATURED",
    icon: gameIcon,
    subLinks: [
      {
        name: "Profile unboxing",
        link: "/create-profile",
      },
    ],
  },
  {
    category: "CRIMES",
    icon: crimeIcon,

    subLinks: [
      {
        name: "Crimes",
        link: "/crimes",
        showCooldown: true,
      },
      {
        name: "Nick a car",
        link: "/nickcar",
        showCooldown: true,
      },
      {
        name: "Travel",
        link: "/travel",
        showCooldown: true,
      },
      {
        name: "Jail",
        link: "/jail",
        showCooldown: true,
      },
      {
        name: "Helper bots",
        link: "/helper",
        showCooldown: false,
      },
      {
        name: "Racing",
        link: "/racing",
        showCooldown: true,
      },
      {
        name: "Organized Crime",
        link: "/organized-crime",
        showCooldown: true,
      },
    ],
  },
  {
    category: "KILL",
    icon: killIcon,
    subLinks: [
      {
        name: "Kill skill",
        link: "/killskill",
        showCooldown: true,
      },
      {
        name: "Kill initiation",
        link: "/kill-initiation",
        showCooldown: true,
      },
      {
        name: "Backfire settings",
        link: "/backfire-settings",
        showCooldown: false,
      },
      {
        name: "Graveyard",
        link: "/graveyard",
        showCooldown: false,
      },
      {
        name: "Attempted kills",
        link: "/attempted-kills",
        showCooldown: false,
      },
    ],
  },
  {
    category: "LOCATION",
    icon: travelIcon,
    subLinks: [
      {
        name: "City map",
        link: "/map",
        needCityId: true,
      },
      {
        name: "Booze",
        link: "/booze",
        showCooldown: true,
      },
      {
        name: "Narcotics",
        link: "/narcotics",
        showCooldown: true,
      },
      {
        name: "Jackpot",
        link: "/jackpot",
        showCooldown: true,
      },
      {
        name: "Lottery",
        link: "/lottery-hall",
        showCooldown: true,
      },
      {
        name: "Roulette",
        link: "/roulette",
      },
      {
        name: "Slotmachine",
        link: "/slotmachine",
      },
      {
        name: "Garage",
        link: "/garage",
      },
      {
        name: "Bullet Factory",
        link: "/bullet/factory",
        showCooldown: true,
      },
      {
        name: "Shop",
        link: "/shop",
        showCooldown: true,
      },
      {
        name: "Bank",
        link: "/bank",
        showCooldown: true,
      },
      {
        name: "Hospital",
        link: "/hospital",
        showCooldown: true,
      },
      {
        name: "Detective Agency",
        link: "/detective-agency",
        showCooldown: true,
      },
      {
        name: "Car Crusher",
        link: "/car-crusher",
        showCooldown: true,
      },
      {
        name: "Safehouse",
        link: "/safehouse",
        showCooldown: true,
      }
    ],
  },
  {
    category: "GAME",
    icon: gameIcon,
    subLinks: [
      {
        name: "Premium",
        link: "/premium",
      },
      {
        name: "My profile",
        link: "/profile",
      },
      {
        name: "Rank Activation",
        link: "/rank-activation",
      },
      {
        name: "Family",
        link: "/family",
      },
      {
        name: "Worth",
        link: "/worth",
      },
      {
        name: "Equipment",
        link: "/equipment",
      },
      {
        name: "Unstake $MAFIA",
        link: "/unstake-mafia",
      },
      {
        name: "Bodyguards",
        link: "/bodyguard",
      },
      {
        name: "Marketplace",
        link: "/market",
      },
      {
        name: "Crates",
        link: "/crate",
      },
      {
        name: "Mystery Box",
        link: "/mysterybox",
      },
      {
        name: "Perks",
        link: "/perks",
      },
      {
        name: "Exchange",
        link: "/exchange",
      },
      {
        name: "XP Market",
        link: "/xpmarket/all",
      },
      {
        name: "Founders table shares",
        link: "/fts",
      },
      {
        name: "Referral",
        link: "/referral",
      },
    ],
  },
  {
    category: "MISC",
    icon: miscIcon,
    subLinks: [
      {
        name: "Vault",
        link: "/vault",
      },
      {
        name: "Vault countdown",
        link: "/vault/countdown",
        showCooldown: true,
      },
      {
        name: "Metrics",
        link: "/metrics",
      },
      {
        name: "Buy $MAFIA",
        link: "/buy",
      },
      {
        name: "Marketing DAO",
        link: "/dao",
      },
      {
        name: "Game wiki",
        link: config.gitbookUrl,
        target: "_blank",
      },
      {
        name: "Terms of Service",
        link: "",
        action: "terms",
      },
    ],
  },
];
